<div class="ui-g-12" style="border: 1px solid black;">
    <div class="ui-g-12" *ngFor='let appoinmentStatus of this.apptStatus;' class="row_appStatus">
        <span [ngClass]="appoinmentStatus+' color_appStatus'"></span>
        <span class="text_appStatus">{{appoinmentStatus}}</span>
    </div>
</div>
<div class="ui-g-12" style="border: 1px solid black;">
    <div class="ui-g-4">
        <b>Patient Name:</b>
        <span class="notranslate">{{this.history.consultation.accounts.first_name+" "+(this.history.consultation.accounts.middle_name==null?'':this.history.consultation.accounts.middle_name)+"
            "+this.history.consultation.accounts.last_name}}</span>
    </div>
    <div class="ui-g-4">
        <b>Consultation Request No :</b><span class="notranslate">{{this.history.consultation.consultation_request_number}}</span> 
    </div>
    <div class="ui-g-4">
        <b>Appoinment Date:</b>{{this.history.consultation.consultation_date | date:'medium'}}
    </div>
    <div class="ui-g-4">
        <b>Consultation Date Requested:</b>{{this.history.consultation.created_at | date:'medium'}}
    </div>
    <div class="ui-g-4">
        <b>Consultation Status:</b>{{this.history.consultation.consultation_status | titlecase}}
    </div>

</div>
<div class="ui-g-12" style="border: 1px solid black;">
    <div class="ui-g-12">
        <div class="ui-g-2">
            <b>Sr. No.</b>
        </div>
        <div class="ui-g-2">
            <b>Action Date</b>
        </div>
        <div class="ui-g-2">
            <b>Action</b>
        </div>
        <div class="ui-g-2">
            <b>Reason</b>
        </div>
        <div class="ui-g-2">
            <b>Doctor Name</b>
        </div>
        <div class="ui-g-2">
            <b>Appointment Date</b>
        </div>
    </div>
    <ng-container *ngFor='let hist of history_array;let last="last"'>
        <div class="ui-g-12" style="border: 1px solid black;color:white;"
            [ngClass]="(hist.status==5)?'Open':apptStatus[(hist.status)-1]">
            <div class="ui-g-2">
                {{hist.sr_no}}
            </div>
            <div class="ui-g-2">
                {{hist.action_date | date:'medium'}}
            </div>
            <div class="ui-g-2">
                {{hist.action_type}}
            </div>
            <div class="ui-g-2">
                {{hist.reason}}
            </div>
            <div class="ui-g-2">
                {{hist.doctor_name}}
            </div>
            <div class="ui-g-2">
                {{hist.appointment_date | date:'medium'}}
            </div>
        </div>
        <div *ngIf="!last" class="ui-g-12">
            <i style="font-size: 25px;font-weight:800;" class="pi pi-arrow-circle-down"></i>
        </div>
    </ng-container>
</div>